import moment from "moment";
import { convertDate } from "utils/formatDate";

//_laiTraGop = 3 (Lãi/triệu/ngày): ChoVay.ValueLai lưu lãi 1 đơn vị kỳ góp như các kiểu khác,
//kỳ góp theo tháng (hoặc ấn định ngày) quy ước 1 tháng = 30 ngày. Phải khớp LaiTrieuNgayRaLaiDonVi ở TraGopController.
//Riêng lãi từng kỳ theo tháng khi rải Paid tính theo số ngày thực tế của kỳ (LaiTrieuNgayTheoThang ở ChoVayManager).
export const LAI_TRA_GOP_TRIEU_NGAY = 3;

const heSoTrieuNgay = (tienVay, theoThang) =>
  (tienVay / 1000000) * (theoThang ? 30 : 1);

export const laiTrieuNgayRaLaiDonVi = (laiTrieuNgay, tienVay, theoThang) =>
  laiTrieuNgay * heSoTrieuNgay(tienVay, theoThang);

export const laiDonViRaLaiTrieuNgay = (laiDonVi, tienVay, theoThang) => {
  const heSo = heSoTrieuNgay(tienVay, theoThang);
  return heSo ? laiDonVi / heSo : 0;
};

//Số ngày thực tế giữa mốc + tuThang và mốc + denThang (cộng tháng kẹp cuối tháng như AddMonths bên C#)
export const soNgayGiuaThang = (moc, tuThang, denThang) => {
  const ngay = moment(moc instanceof Date ? moc : convertDate(moc));
  if (!moc || !ngay.isValid()) return 30 * (denThang - tuThang);
  ngay.startOf("day");
  return ngay
    .clone()
    .add(denThang, "months")
    .diff(ngay.clone().add(tuThang, "months"), "days");
};
